import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getSocialHandleAvailability,
  type HandleAvailabilityDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import {
  isReservedHandle,
  isValidHandle,
  normalizeHandle,
} from "Schemas/handleSchema";

const HANDLE_AVAILABILITY_QUERY_KEY = "SOCIAL_HANDLE_AVAILABILITY";

export const handleAvailabilityKeys = {
  all: [HANDLE_AVAILABILITY_QUERY_KEY] as const,
  byHandle: (handle: string) =>
    [...handleAvailabilityKeys.all, handle] as const,
};

/**
 * Live availability for the handle editor. Only fires for locally valid, non-reserved
 * handles (the backend reports both as unavailable anyway, and the form surfaces those
 * cases via schema validation); callers debounce the input.
 */
export const useHandleAvailabilityQuery = (handle: string) => {
  const normalizedHandle = normalizeHandle(handle);

  return useQuery<HandleAvailabilityDto>({
    queryKey: handleAvailabilityKeys.byHandle(normalizedHandle),
    queryFn:
      isValidHandle(normalizedHandle) && !isReservedHandle(normalizedHandle)
        ? processResponseWithApiProblemDetails(() =>
            getSocialHandleAvailability(normalizedHandle),
          )
        : skipToken,
  });
};
